import {
  ASSESSMENT_MODE_FULL_ONLY,
  assessmentModeLabel,
} from "./inviteOptions";

/**
 * Assessment path on invite compose — read-only, aligned with workspace product settings.
 */
export default function InviteAssessmentOptions({
  litePathAvailable = true,
  assessmentMode = null,
  offerLiteReport = "Y",
  compact = false,
  className = "",
}) {
  const modeLabel = assessmentModeLabel(
    litePathAvailable ? assessmentMode : ASSESSMENT_MODE_FULL_ONLY
  );
  const showLiteReport =
    litePathAvailable &&
    assessmentMode !== ASSESSMENT_MODE_FULL_ONLY &&
    String(offerLiteReport || "Y").toUpperCase() === "Y";

  if (!litePathAvailable) {
    if (compact) {
      return (
        <p className={`text-xs text-gray-500 ${className}`}>
          Full assessment only (LITE is disabled for this workspace).
        </p>
      );
    }
    return (
      <div className={`rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700 ${className}`}>
        <p className="font-medium text-gray-900">Assessment path</p>
        <p className="text-xs text-gray-600 mt-0.5">
          Participants start on the full assessment. LITE is turned off in product settings.
        </p>
      </div>
    );
  }

  if (compact) {
    return (
      <p className={`text-xs text-gray-500 ${className}`}>
        {modeLabel}
        {showLiteReport ? " · LITE report included" : ""}
      </p>
    );
  }

  return (
    <div className={`space-y-2 ${className}`}>
      <div>
        <p className="text-sm font-medium text-gray-900">Assessment path</p>
        <p className="text-xs text-gray-500 mt-0.5">
          Set in workspace product settings. New invites use the path below.
        </p>
      </div>
      <div className="rounded-lg border border-[#004f73]/30 bg-[#004f73]/5 px-3 py-2.5 text-sm">
        <p className="font-medium text-gray-900">{modeLabel}</p>
        {showLiteReport ? (
          <p className="text-xs text-gray-600 mt-0.5">
            Short LITE assessment and LITE report, then optional continue to full
          </p>
        ) : assessmentMode === ASSESSMENT_MODE_FULL_ONLY ? (
          <p className="text-xs text-gray-600 mt-0.5">
            Participants start on the full assessment
          </p>
        ) : (
          <p className="text-xs text-gray-600 mt-0.5">
            LITE path without offering the LITE report PDF
          </p>
        )}
      </div>
    </div>
  );
}
